import React, { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';
import { formatDate } from '@utils/dates/date.utils';
import { MM_SLASH_DD_SLASH_YYYY } from '@utils/dates/dateFormats.utils';


const SecureInboxTableRow = props => {
    const intl = useIntl();

    const {
        row: email,
        row: {
            emailSubject,
            date,
            pdfFileKey,
            read
        },
        setEmailShown
    } = props;

    const setEmailDate = dateValue => formatDate(dateValue, MM_SLASH_DD_SLASH_YYYY);

    const handleRowClick = () => {
        setEmailShown(email);
    };

    const handleKeyDown = e => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleRowClick();
        }
    };

    const formattedDate = setEmailDate(date);
    const readStatus = read 
        ? intl.formatMessage({ id: 'common.inbox.aria.status.read' }) 
        : intl.formatMessage({ id: 'common.inbox.aria.status.unread' });
    const attachmentText = pdfFileKey 
        ? intl.formatMessage({ id: 'common.inbox.aria.has_attachment' }) 
        : '';
    
    const rowAriaLabel = intl.formatMessage(
        { id: 'common.inbox.row.aria_label' },
        { 
            subject: emailSubject, 
            date: formattedDate, 
            status: readStatus,
            attachment: attachmentText
        }
    );

    const TABLE_ROW_DATA_DEFAULT = {
        DATE: formattedDate,
        EMAIL_SUBJECT: emailSubject,
        PDF: pdfFileKey 
            ? <FontAwesomeIcon icon='paperclip' aria-hidden="true" /> 
            : ''
    };

    const rowDataObj = TABLE_ROW_DATA_DEFAULT;
    return (
        <Fragment>
            <tr
                className={ 'pointer' + `${ read ? '' : ' text-bold' }` }
                tabIndex="0"
                role="row"
                aria-label={rowAriaLabel}
                onClick={handleRowClick}
                onKeyDown={handleKeyDown}
            >
                {Object.keys(rowDataObj).map((tableDataKey) => (
                    <td key={tableDataKey}> {rowDataObj[tableDataKey] }</td>
                ))}
            </tr>
        </Fragment>
    );
};


export default SecureInboxTableRow;